import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
	body: '#FF0000',
	white: '#FFFFFF',
	gray: {
		0: '#FCFCFC',
		50: '#FF0000',
		100: '#F6F6F6',
		200: '#E6E6E6',
		300: '#FF0000',
		400: '#B2B2B2',
		500: '#FF0000',
		600: '#606060',
		700: '#707070',
		800: '#909090',
		900: '#2f2f2f',
		1000: '#1A1A1A',
	},
	blue: {
		300: '#E5F4FF',
		500: '#008EF8',
		600: '#007DD4',
		700: '#0063ab',
		900: '#8CDFF2',
		1000: '#C0F3FF',
	},
	red: {
		500: '#EF4444',
		700: '#B23232',
	},
	green: {
		200: '#B4FEA0',
		400: '#97d587',
		600: '#5CAA3A',
		800: '#0DB43C',
	},
};

export const darkTheme: DefaultTheme = {
	body: '#FF0000',
	white: '#1E1E1E',
	gray: {
		0: '#272727',
		50: '#FF0000',
		100: '#313131',
		200: '#3C3C3C',
		300: '#FF0000',
		400: '#7D7D7D',
		500: '#FF0000',
		600: '#BDBDBD',
		700: '#C0C0C0',
		800: '#D8D8D8',
		900: '#F0F0F0',
		1000: '#FFFFFF',
	},
	blue: {
		300: '#4A5878',
		500: '#0080E0',
		600: '#007DD4',
		700: '#0586e3',
		900: '#8CDFF2',
		1000: '#C0F3FF',
	},
	red: {
		500: '#EF4444',
		700: '#F97878',
	},
	green: {
		200: '#4D8D32',
		400: '#5CAA3A',
		600: '#97d587',
		800: '#B4FEA0',
	},
};

export const unthemed = lightTheme;

export const shadows = {
	sm: '0 1px 4px rgba(0, 0, 0, 0.15)',
	md: '0 6px 12px rgba(0, 0, 0, 0.15)',
};

// the basic step size of our UI grid
export const step = 8;
//  sometimes, we use a half-step
export const halfStep = 4;

export const layout = {
	// the height (in px) of the header that appears above our frames, this never scales
	// even if the scene is scaling underneath it
	frameHeaderHeight: 18,
	panelInitialWidth: 270,
	chatPanelInitialWidth: 420,
	panelMinWidth: 100,
	panelMaxWidth: 600,
	inspectorNavbarHeight: 50,
};

export const zIndex = {
	//--------------------------------------------------
	// EDITING EXPERIENCE

	// the UI layer which hosts the the frame editing experience
	ui: 0,

	// navigator, property panels, etc
	panel: 3,
	panelOverlay: 4,

	modal: 5, // modals that float on top of our UI

	island: 7,

	// Context menus should appear above nearly everything else
	// Our modals have a z-index of 100, so we need to be above them
	contextMenu: 101,

	loading: 9, // loading spinner

	help: 10, // help button, visible even when loading! (in case we get stuck loading)
};
